module.exports = __webpack_public_path__ + "img/yxmh_01.dc286d94.jpg";